var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"citToolbar"},_vm._l((_vm.config),function(tool){return _c('span',{key:tool.name},[_c('Tool',{attrs:{"tool":tool},on:{"setValue":_vm.setToolValue,"setOption":_vm.setToolOption,"setActive":_vm.setToolActive}}),(_vm.toolbarGroup.includes(tool.name))?_c('span',{staticClass:"groupBar"}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }